'use client'

import { usePostHog } from '@posthog/next'
import { usePathname, useSearchParams } from 'next/navigation'
import { Suspense, useEffect, useEffectEvent } from 'react'

import { usePlatformAdFree } from '@/hooks/usePlatformAdFree'

const AD_ELIGIBLE_PAGEVIEW_EVENT = 'ad_eligible_pageview'

type AdEligiblePageViewProps = {
  pageType: 'landing' | 'content-detail'
}

function AdEligiblePageViewTracker({ pageType }: AdEligiblePageViewProps) {
  const posthog = usePostHog()
  const pathname = usePathname()
  const search = useSearchParams().toString()
  const { isAdFree, adFreeReason } = usePlatformAdFree()

  const captureAdEligiblePageView = useEffectEvent(() => {
    posthog.capture(AD_ELIGIBLE_PAGEVIEW_EVENT, {
      is_ad_free: isAdFree,
      ad_free_reason: adFreeReason,
      page_type: pageType,
    })
  })

  useEffect(() => {
    captureAdEligiblePageView()
  }, [pathname, search])

  return null
}

export default function AdEligiblePageView(props: AdEligiblePageViewProps) {
  return (
    <Suspense fallback={null}>
      <AdEligiblePageViewTracker {...props} />
    </Suspense>
  )
}
